/**
 * Generates a UUID in 32 hex character format (no hyphens)
 * Used for answer_group_id in repeating answer groups
 */
export function generateUUID32Hex(): string {
  // Generate UUID and remove hyphens
  return crypto.randomUUID().replace(/-/g, '');
}
